import gql from 'graphql-tag'

const listAdyenStores = gql`
	query listAdyenStores {
		cashAssist {
			listAdyenStores {
			id
			name
		}
	}
}
`

export default listAdyenStores
